appSocial.service('SocialFavoriteService', [
    '$rootScope', 'SocialAPIService', 'SocialUserService', 'SocialPortfolioService', 'Trader',
    function ($rootScope, SocialAPIService, SocialUserService, SocialPortfolioService, Trader) {

        class SocialFavoriteService {
            constructor() {
                /**
                 * @type {SocialAPIService}
                 */
                this.api = SocialAPIService;
                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;
                /**
                 * @type {SocialPortfolioService}
                 */
                this.portfolioService = SocialPortfolioService;

                /**
                 * @type {Trader[]}
                 */
                this.traders = [];

                this.isLocal = true;
            }

            init() {
                const user = this.userService.get();
                if (user.id) {
                    return this.api.request.getFavorites()
                        .then((response) => response.traders.map(item => {
                            const trader = new Trader(item);
                            trader.isFavorite = true;
                            return trader;
                        }))
                        .then((traders) => this.portfolioService.reInitLeaders(traders))
                        .then((traders) => {
                            this.isLocal = false;
                            this.traders = traders;
                        });
                }
                return Promise.resolve();
            }


            reload() {
                return this.init();
            }

            clear() {
                this.traders = [];
                this.isLocal = true;
            }

            /**
             *
             * @param {string} traderId
             * @return {boolean}
             */
            isFavorite(traderId) {
                return !!_.find(this.traders, {id: traderId});
            }

            /**
             * Add to favorites
             * @param {Trader} trader
             * @return {*}
             */
            addFavorite(trader) {
                trader.isFavorite = true;
                this.traders.push(trader);

                if (!this.isLocal) {
                    return this.api.request.addFavorite({leader_id: trader.id})
                        .then(() => $rootScope.$emit('SocialFavoriteService.change'));
                }

                $rootScope.$emit('SocialFavoriteService.change');
            }

            /**
             * Remove from favorites
             * @param {Trader} trader
             * @return {*}
             */
            deleteFavorite(trader) {
                trader.isFavorite = false;
                _.remove(this.traders, {id: trader.id});

                if (!this.isLocal) {
                    return this.api.request.deleteFavorite('', {leader_id: trader.id})
                        .then(() => $rootScope.$emit('SocialFavoriteService.change'));
                }

                $rootScope.$emit('SocialFavoriteService.change');
            }

            /**
             * Toggle
             * @param {Trader} trader
             */
            toggleFavorite(trader) {
                if (trader.isFavorite) {
                    this.deleteFavorite(trader);
                } else {
                    this.addFavorite(trader);
                }
            }
        }


        return new SocialFavoriteService();
    }])
